function appendParam(url, key, value) {
  var separator = url.indexOf('?') === -1 ? '?' : '&'
  return url + separator + encodeURIComponent(key) + '=' + encodeURIComponent(value)
}

export function withForgePlatformOrigin(url) {
  return appendParam(url, 'platform_origin', window.location.origin)
}

export function openForgeAppWithToken(vm, url, appRef) {
  var appWindow = window.open('about:blank', '_blank')

  function fail(err) {
    console.error('[forge] token delivery failed', err)
    if (appWindow && !appWindow.closed) {
      appWindow.close()
    }
    if (vm.$bvToast) {
      vm.$bvToast.toast(vm.$t('unexpectedError'), { variant: 'danger' })
    }
  }

  if (!appWindow) {
    fail(new Error('popup blocked'))
    return
  }

  vm.$http.post('/v1/system/platform/forge/token', { app_ref: appRef }).then(function(resp) {
    if (!resp.data || !resp.data.token) {
      fail(new Error('forge token response did not include a token'))
      return
    }

    var launchUrl = withForgePlatformOrigin(url)
    launchUrl = appendParam(launchUrl, 'token', resp.data.token)
    appWindow.location.href = launchUrl
  }).catch(fail)
}
